import * as React from "react";
const SvgPenIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.6667 4.99857L15 8.33191M3.48061 17.3025L5.08325 16.9819C5.67181 16.8642 5.96608 16.8054 6.2405 16.6977C6.48407 16.6022 6.71554 16.4783 6.93014 16.3286C7.17191 16.16 7.38412 15.9478 7.80853 15.5234L16.5572 6.77471C16.8872 6.4447 17.0522 6.27969 17.1141 6.08942C17.1684 5.92205 17.1684 5.74176 17.1141 5.57439C17.0522 5.38412 16.8872 5.21911 16.5572 4.8891L15.1095 3.44138C14.7795 3.11137 14.6145 2.94636 14.4242 2.88454C14.2568 2.83015 14.0766 2.83015 13.9092 2.88454C13.7189 2.94636 13.5539 3.11137 13.2239 3.44138L4.4752 12.1901C4.05079 12.6145 3.83858 12.8267 3.66996 13.0685C3.52029 13.2831 3.39641 13.5145 3.30087 13.7581C3.19324 14.0325 3.13438 14.3268 3.01667 14.9154L2.69615 16.518C2.63057 16.8459 2.59779 17.0098 2.64616 17.1267C2.68845 17.2289 2.76966 17.3101 2.87189 17.3524C2.98881 17.4008 3.15275 17.368 3.48061 17.3025Z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgPenIcon;
